import React, {Component} from 'react';
import {Item, Segment} from 'semantic-ui-react';
import ProductTable from "../ProductTable/index";

export default class ProductGroup extends Component {


    render() {

        const {groupID, group} = this.props;
        if (groupID === 'null') {
            return (
                <div key={'noMatrix'}>
                    {group.map((product) => {
                        return (
                            <Segment key={product.id}>
                                <Item>
                                    {product.code.includes('RUK') && this.props.picture &&
                                    <Item.Image size='tiny'
                                                src={'https://www.rutishauser.com/productimages/' + product.code.replace('RUK', '') + '.png'}/>
                                    }
                                    <Item.Content>
                                        <Item.Header as='h2'>{product.code} - {product.name}</Item.Header>
                                        <Item.Description>
                                            <ProductTable product={product}/>
                                        </Item.Description>
                                    </Item.Content>

                                </Item>
                            </Segment>)
                    })}
                </div>
            );
        }

        return (
            <Segment key={groupID}>
                <Item>
                    {group[0].code.includes('RUK') && this.props.picture &&
                    <Item.Image size='tiny'
                                src={'https://www.rutishauser.com/productimages/' + group[0].code.replace('RUK', '') + '.png'}/>
                    }
                    <Item.Content>
                        <Item.Header as='h2'>{group[0].parent_code} - {group[0].parent_name}</Item.Header>
                        <Item.Description>
                            <ProductTable {...this.props} />
                        </Item.Description>
                    </Item.Content>

                </Item>
            </Segment>
        )
    }


}




// WEBPACK FOOTER //
// ./src/scenes/Inventory/components/ProductGroup/index.js